import { DxImageWithPointsAndConditions } from '../imageDxTypes';
import { dogPainDxImages } from './dogPainDxImages';
import { equinePainDxImages } from './equinePainDxImages';
import { equinePainSimpleDxImages } from './equinePainSimpleDxImages';
import { felineDxImages } from './felinePainDxImages';

const dxImages = {
  dogPainDxImages,
  equinePainDxImages,
  equinePainSimpleDxImages,
  felineDxImages
} as const;

type DxImagesSetName = keyof typeof dxImages;
const DxImagesSets: Record<DxImagesSetName, DxImageWithPointsAndConditions[]> = dxImages;

export { dogPainDxImages, equinePainSimpleDxImages, DxImagesSets, type DxImagesSetName };
